import { ICustomizationState } from "@multiweb/reactCustomization";
import { IAggregationRowState } from "../aggregationRow/types";
import { LinkButtonMapState } from "../components/LinkButton/types";
import { IReportingScalarState } from "../components/ReportingScalar/types";
import { IControlsState } from "../controls/types";
import { ICoreState } from "../core/types";
import { FormsMapState } from "../forms/types";
import { FramesMapState } from "../frames/types";
import { IMenuState } from "../menu/types";
import { RightsState } from "../rights/types";
import { IWorkflowEditorState } from "../workflowEditor/types";

/**
 * Reprezentuje strukturu reduxového stavu.
 */
export interface IAppState {
    readonly core: ICoreState;
    readonly customization: ICustomizationState;
    readonly menu: IMenuState;
    readonly aggregationRow: IAggregationRowState;
    readonly workflowEditor: IWorkflowEditorState;
    readonly controls: IControlsState;
    readonly frames: FramesMapState;
    readonly forms: FormsMapState;
    readonly rights: RightsState;
    readonly reportingScalar: IReportingScalarState;
    readonly linkButton: LinkButtonMapState;
}
